import { type RegistrationType } from '@exam-center/graphql';
import { FormSearchMultipleSelection } from '@shared/components';

const REGISTRATION_TYPE_OPTIONS = [
  { label: 'Public', value: 'PUBLIC' },
  { label: 'In-house', value: 'IN_HOUSE' },
];

interface RegistrationTypeSearchSelectionProps {
  name: string;
  value: RegistrationType[];
}

export default function RegistrationTypeSearchSelection(
  props: Readonly<RegistrationTypeSearchSelectionProps>,
) {
  const { name, value } = props;
  return (
    <FormSearchMultipleSelection
      options={REGISTRATION_TYPE_OPTIONS}
      label='Registration Type'
      name={name}
      sx={{ width: '100%' }}
      slotProps={{
        input: { placeholder: value.length === 0 ? 'แสดงทั้งหมด' : '' },
      }}
    />
  );
}
